import React from "react";
import { SEO } from "../SEO";
import Navbar from "../Navbar";
import PageFooter from "../PageFooter";
import BlogIndex from "../BlogIndex";
import WindowSizeContext from "../../contexts/windowSizeContext";
import useWindowSize from "../../hooks/useWindowSize";
import useIpGeoData from "../../hooks/useIpGeoData";
import IpGeoDataContext from "../../contexts/ipGeoDataContext";

import "../../css/core.css";

/**
 * The default layout component for MDX rendered Blog pages.
 *
 * This layout page sets the WindowSizeContext from the useWindowSize hook.
 *
 * @param {Props} props Array of data passed to the function from the parent component and the rendering pipeline.
 * @returns (element) A layout page, configured with the meta data passed, which renders the child elements passed.
 */
export default (props) => {
  const { pageMetaData, children } = props;
  const { pageTitle, pageDescription, pageImagePath, pageMetaTags } = pageMetaData;
  const windowSize = useWindowSize();
  const ipGeoData = useIpGeoData();

  return (
    <WindowSizeContext.Provider value={windowSize}>
      <IpGeoDataContext.Provider value={ipGeoData}>
        <div className="flex flex-col min-h-screen font-body">
          <SEO title={pageTitle} description={pageDescription} pageImagePath={pageImagePath} meta={pageMetaTags} isBlogPost={true} />
          <header>
            <Navbar />
          </header>
          <main className="content">
            <div className="container mx-auto">
              <BlogIndex content={children} />
            </div>
          </main>
          <footer>
            <PageFooter />
          </footer>
        </div>
      </IpGeoDataContext.Provider>
    </WindowSizeContext.Provider>
  );
};
